export default __webpack_public_path__ + "static/media/gift.6b7d302b.svg";